export default (f) => {
  let resolve, reject, cancelled;
  const promise = new Promise((resolveFromPromise, rejectFromPromise) => {
    resolve = resolveFromPromise;
    reject = rejectFromPromise;
  }).catch(err => { }); //ignored

  
    f.then(wrapWithCancel())
    .catch((error) => console.error(error))
    .then(resolve)
    .then(reject);

  return {
    promise,
    cancel: () => {
      cancelled = true;
      reject({ reason: 'cancelled' });
    }
  };

  function wrapWithCancel() {
    return (data) => {
      if (!cancelled) {
        return data;
      }
    };
  }
}


// WEBPACK FOOTER //
// ./src/utils/cancellablePromise.js